import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import dataSourcesListMixin from '@/components/core/dtwin/state/dataSourcesListMixin';
import ApiService from '@/services/apiService';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
var stubNewMeterObject = {
  reuseParentScope: false,
  title: 'Meterpoint',
  data: {
    type: 'meterpoint',
    keyValue: {
      'Customer ID': '',
      heatmonitoring_create_unit: 'kWh',
      heatmonitoring_create_addmeterstate: false
    }
  },
  properties: {}
};
var subNewMeterStateObject = {
  properties: {
    binding: {
      options: {}
    }
  }
};
export default {
  name: 'ViewISHeatMonitoringMeterPointList',
  mixins: [dataSourcesListMixin],
  data: function data() {
    return {
      showDialogStatistics: false,
      // only show "map" button if the current user has access to ANY devices with geo-coordinates
      hasAnyGeoDevices: false,
      favouriteFilter: false,
      showDialogCreate: false,
      showDialogEditAll: false,
      selectedAccounts: [],
      selectedRows: [],
      //
      searchItems: [],
      searchTags: [],
      searchZones: [],
      bridgeTypes: [],
      accounts: [],
      createData: {
        createInProgress: false,
        selectedAccount: null,
        formValid: false,
        meterPointObj: {},
        meterState: {}
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isTwinManager: function isTwinManager() {
      return this.permissions['DigitalTwin.manage'];
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    searchTypes: function searchTypes() {
      return [{
        text: this.$i18n_t('Common.id'),
        param: 'id'
      }, {
        text: this.$i18n_t('IS.HeatMonitoring.customerId'),
        param: 'customerId'
      }, {
        text: this.$i18n_t('IS.HeatMonitoring.meterId'),
        param: 'meterId'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.keyValue'),
        param: 'keyValue'
      }];
    },
    showAccountFilter: function showAccountFilter() {
      return this.permissions['IsHeatMonitoring.manage'] || this.permissions['all.manage'];
    },
    sourcesNameMapping: function sourcesNameMapping() {
      return {
        'virtual-device': this.$i18n_t('IS.HeatMonitoring.drawer.isHeatMonitoringMeters'),
        'virtual-device-aggregate': "".concat(this.$i18n_t('IS.HeatMonitoring.drawer.isHeatMonitoringMeters'), " ").concat(this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.aggregate'))
      };
    }
  }),
  watch: {
    language: function language() {
      (this.searchTypes.find(function (item) {
        return item.param === 'tag';
      }) || {}).items = this.searchTags;
      (this.searchTypes.find(function (item) {
        return item.param === 'zone';
      }) || {}).items = this.searchZones;
    },
    'createData.selectedAccount': function createDataSelectedAccount() {
      this.fetchAccountRootTwin();
    }
  },
  created: function created() {
    this.fetchAccounts();
  },
  mounted: function mounted() {
    var _this2 = this;

    this.getMultiFilterData();
    ApiService.isHeatMonitoringCheckForGeoClusters(this).then(function (res) {
      _this2.hasAnyGeoDevices = res.hasGeoDevices;
    }).catch(function (error) {
      console.error(error);
    });
  },
  methods: {
    fetchAccounts: function fetchAccounts() {
      var _this3 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        // filter the root-tenant, because that one does not have a twin to attach the new device to
        _this3.accounts = accounts.filter(function (t) {
          return !t.isRootTenant;
        });
      }).catch(function (error) {
        console.error(error);

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    fetchAccountRootTwin: function fetchAccountRootTwin() {
      var _this4 = this;

      // fetch the first found twin for this account
      // is hopefully the root-twin
      ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, this.createData.selectedAccount).then(function (res) {
        _this4.createData.meterPointObj.parentId = get(res, 'digitaltwins[0].id', null);
        _this4.createData.meterPointObj = cloneDeep(_this4.createData.meterPointObj);
      }).catch(function (error) {
        console.error('Error fetching account root twin', error);
      });
    },
    parentSelectorFilter: function parentSelectorFilter(item) {
      return (// only allow new parents from the same tenant
        item.tenantId === this.createData.selectedAccount
      );
    },
    openCreateDialog: function openCreateDialog() {
      this.createData.meterPointObj = cloneDeep(stubNewMeterObject);
      this.createData.meterState = cloneDeep(subNewMeterStateObject);
      this.createData.selectedAccount = null;
      this.showDialogCreate = true;
    },
    updateList: function updateList() {
      this.$refs.list.fetchList();
    },
    updateRowsSelected: function updateRowsSelected(rows) {
      this.selectedRows = rows;
    },
    getMultiFilterData: function getMultiFilterData() {
      var _this5 = this;

      ApiService.isHeatMonitoringFetchTagsAndZones(this, 'meterpoint').then(function (result) {
        _this5.searchTags = result.tagList;
        _this5.searchZones = result.zoneList;
        (_this5.searchTypes.find(function (item) {
          return item.param === 'tag';
        }) || []).items = result.tagList;
        (_this5.searchTypes.find(function (item) {
          return item.param === 'zone';
        }) || []).items = result.zoneList;
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateStateUnit: function updateStateUnit() {
      var newUnit = get(this.$refs, 'virtualDeviceBindingEdit.selectedVirtualDeviceState[0].properties.unit');
      this.createData.meterPointObj.data.keyValue['heatmonitoring_create_unit'] = newUnit || this.createData.meterPointObj.data.keyValue['heatmonitoring_create_unit'];
    },
    createMeteringPoint: function createMeteringPoint() {
      var _this6 = this;

      this.createData.createInProgress = true;
      this.$refs['virtualDeviceBindingEdit'].saveState();
      this.createData.meterPointObj.data.keyValue['heatmonitoring_create_device_id'] = get(this.createData, 'meterState.properties.binding.options.virtualDevice.id');
      this.createData.meterPointObj.data.keyValue['heatmonitoring_create_state_id'] = get(this.createData, 'meterState.properties.binding.options.virtualDevice.stateId');
      return ApiService.digitalTwinCreate(this, this.createData.meterPointObj).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this6.showDialogCreate = false;
                _this6.createData.selectedAccount = null;

                _this6.updateList();

                _this6.$snack(_this6.$i18n_t('Common.digitalTwins.twinCreated'), 'success');

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))).catch(function (error) {
        if (error.response && _this6.$i18n_t('Error')[error.response.data.message]) {
          _this6.$snack(_this6.$i18n_t('Error')[error.response.data.message], 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('Common.digitalTwins.twinCreatedFail'), 'error');
        }
      }).finally(function () {
        _this6.createData.createInProgress = false;
      });
    }
  }
};